const collections = [
  { title: '暑期档热映大片合集', desc: '2026暑期最热门院线大片全收录', count: '68部', icon: 'ri-movie-2-line' },
  { title: '豆瓣TOP250经典', desc: '评分最高250部电影一网打尽', count: '250部', icon: 'ri-medal-line' },
  { title: '国漫精品专区', desc: '国产动画崛起之路精选佳作', count: '142部', icon: 'ri-rocket-2-line' },
  { title: '港片黄金年代', desc: '80-90年代经典港片修复合集', count: '210部', icon: 'ri-vidicon-line' },
  { title: '日韩剧场', desc: '最新日韩电视剧同步更新中', count: '385部', icon: 'ri-global-line' },
  { title: '悬疑烧脑片单', desc: '高智商推理与心理悬疑精选', count: '156部', icon: 'ri-brain-line' },
  { title: '合家欢影院', desc: '适合全家一起看的温馨好片', count: '203部', icon: 'ri-heart-line' },
  { title: '4K超清体验', desc: '极致画质观影体验专区', count: '96部', icon: 'ri-4k-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-500">精心策划主题片单，发现更多精彩</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {collections.map((c, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-start gap-4 p-5 rounded-lg bg-background-100 hover:bg-background-200/60 border border-background-200/40 hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${c.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-100 group-hover:text-primary-400 transition-colors mb-1">
                  {c.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">{c.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{c.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}